module.exports = __webpack_public_path__ + "img/hero.39f3dcb4.png";